// Country ISO 3166 => VAT %

export default {
	at: 20, // Austria
	be: 21, // Bélgica
	bg: 20, // Bulgaria
	cy: 19, // Chipre
	cz: 21, // Chequia
	de: 19, // Alemania
	dk: 25, // Dinamarca
	ee: 20, // Estonia
	el: 24, // Grecia
	gr: 24, // Grecia
	es: 21, // España
	fi: 25.5, // Finlandia
	fr: 20, // Francia
	hr: 25, // Croacia
	hu: 27, // Hungría
	ie: 23, // Irlanda
	it: 22, // Italia
	lt: 21, // Lituania
	lu: 17, // Luxemburgo
	lv: 21, // Letonia
	mt: 18, // Malta
	nl: 21, // Países Bajos
	pl: 23, // Polonia
	pt: 23, // Portugal
	ro: 19, // Rumanía
	se: 25, // Suecia
	si: 22, // Eslovenia
	sk: 23 // Eslovaquia
};
